document.addEventListener('DOMContentLoaded', function () {
  const headerWrapper = document.querySelector('.header-group-wrapper');

  if (!headerWrapper) return;

  const HIDDEN_CLASS = 'show_fixed';
  const VISIBLE_CLASS = 'show-fixed-visible';
  const MIN_SCROLL_DELTA = 8;
  const TOP_RESET_THRESHOLD = 2;

  let lastScrollY = 0;
  let ticking = false;
  let headerState = headerWrapper.classList.contains(VISIBLE_CLASS)
    ? 'visible'
    : headerWrapper.classList.contains(HIDDEN_CLASS)
      ? 'hidden'
      : 'top';

  const setHeaderState = (nextState) => {
    if (nextState === headerState) return;

    headerState = nextState;

    if (nextState === 'top') {
      headerWrapper.classList.remove(HIDDEN_CLASS, VISIBLE_CLASS);
      return;
    }

    headerWrapper.classList.add(HIDDEN_CLASS);

    if (nextState === 'visible') {
      headerWrapper.classList.add(VISIBLE_CLASS);
    } else {
      headerWrapper.classList.remove(VISIBLE_CLASS);
    }
  };

  const updateHeader = () => {
    ticking = false;

    const currentScrollY = Math.max(
      window.scrollY || document.documentElement.scrollTop || 0,
      0
    );
    const scrollDelta = currentScrollY - lastScrollY;
    const headerHeight = headerWrapper.offsetHeight || 0;

    if (currentScrollY <= TOP_RESET_THRESHOLD) {
      setHeaderState('top');
      lastScrollY = currentScrollY;
      return;
    }

    if (Math.abs(scrollDelta) < MIN_SCROLL_DELTA) return;

    if (
      scrollDelta > 0 &&
      currentScrollY < headerHeight &&
      headerState !== 'hidden'
    ) {
      lastScrollY = currentScrollY;
      return;
    }

    setHeaderState(scrollDelta > 0 ? 'hidden' : 'visible');
    lastScrollY = currentScrollY;
  };

  const requestHeaderUpdate = () => {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updateHeader);
  };

  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  window.addEventListener('resize', requestHeaderUpdate);

  updateHeader();
});
